module.exports = __webpack_public_path__ + "static/media/f27kz.676dc990.pdf";